import { render, staticRenderFns } from "./aidApplyInfo.vue?vue&type=template&id=37062218&scoped=true&"
import script from "./aidApplyInfo.vue?vue&type=script&lang=js&"
export * from "./aidApplyInfo.vue?vue&type=script&lang=js&"
import style0 from "./aidApplyInfo.vue?vue&type=style&index=0&id=37062218&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37062218",
  null
  
)

export default component.exports